import { Outlet, useSearchParams } from 'react-router-dom'

import { PublicApprovals } from '../../screens/publicApprovals/PublicApprovals'

import { EPublicApprovalScreenParams } from '../../enums/EPublicApprovalScreenParams'

const trueString = 'true'

export function RedirectByParams() {
    let [searchParams, setSearchParams] = useSearchParams()

    function validateParamsToRedirect(EnumParamsToRedirect = {}) {
        return Object.values(EnumParamsToRedirect).every((param) => searchParams.get(param))
    }

    if (validateParamsToRedirect(EPublicApprovalScreenParams)) {
        const isApproval = searchParams.get(EPublicApprovalScreenParams.APPROVING) === trueString
        return <PublicApprovals isApproval={isApproval} />
    }

    return <Outlet />
}
